import type { ResendAccountInvitationCommand, ResendAccountInvitationResult } from "../model/Invitation";
import type { AccountManagementService } from "../port/AccountManagementService";

export class ResendAccountInvitation {
  constructor(private readonly service: AccountManagementService) {}

  execute(
    command: ResendAccountInvitationCommand,
    signal?: AbortSignal,
  ): Promise<ResendAccountInvitationResult> {
    return this.service.resendAccountInvitation(command, signal);
  }
}
